
module.exports = {
    myHost: {
       'host':'https://api-doc.smicee.com'
    }
};
